
let phraseMap = {
    LABEL_STD_DOCUMENT: 'Type',
    LABEL_TITLE: 'Title',
    LABEL_REFERENCE: 'Reference',
    LABEL_VERSION: 'Version',
    LABEL_SERIAL_NUMBER: 'Serial Number',
    LABEL_SUPERSEDED_BY: '',
    LABEL_CREATED_AUTOMATICALLY: 'Created automatically.',
    LABEL_CLASSIFICATION: 'Classification',
    LABEL_FILE_LOCATION: 'File Location',

    DOCUMENT_CREATED_AUTOMATICALLY: 'Created automatically.',
    DOCUMENT_LABEL_ISSUE_NUMBER: 'Issue',
    DOCUMENT_LABEL_NOTE: 'Note',
    DOCUMENT_INFO_NOTE: 'Notes are carried forward into future versions.',
    DOCUMENT_LABEL_OWNER: 'Owner',
    DOCUMENT_LABEL_ISSUE_DATE: 'Issue Date',
    DOCUMENT_LABEL_STATUS: 'Status',
    DOCUMENT_LABEL_MODEL: 'Models',

    CUSTOMER_DOCUMENT_LABEL_ISSUE: 'Issue',
    CUSTOMER_DOCUMENT_LABEL_REVISION: 'Revision',
    CUSTOMER_DOCUMENT_LABEL_ISSUE_DATE: 'Issue Date',
    CUSTOMER_DOCUMENT_LABEL_ORGANISATION_CODE: 'Customer Org Code',
    CUSTOMER_DOCUMENT_LABEL_ELEMENT_CODE: 'Element',
    CUSTOMER_DOCUMENT_LABEL_CREATE_DATE: 'Issue Date',
    CUSTOMER_DOCUMENT_LABEL_RECEIVE_DATE: 'Date Received',
    CUSTOMER_DOCUMENT_LABEL_NOTE: 'Notes',
    CUSTOMER_DOCUMENT_LABEL_STATUS: 'Status',
    CUSTOMER_DOCUMENT_LABEL_MODEL: 'Models',
    CUSTOMER_DOCUMENT_HEADER_INFORMATION: 'Document Information (As-Given)',
    CUSTOMER_DOCUMENT_HEADER_ADDITIONAL: 'Additional Information',
    CUSTOMER_DOCUMENT_CREATE_DATE_REQUIRED: 'Issue Date is required',
    CUSTOMER_DOCUMENT_RECEIVE_DATE_REQUIRED: 'Date Received is required',

    SUPPLIER_DOCUMENT_LABEL_ISSUE: 'Issue',
    SUPPLIER_DOCUMENT_LABEL_REVISION: 'Revision',
    SUPPLIER_DOCUMENT_LABEL_ISSUE_DATE: 'Issue Date',
    SUPPLIER_DOCUMENT_LABEL_ORGANISATION_CODE: 'Supplier Org Code',
    SUPPLIER_DOCUMENT_LABEL_ELEMENT_CODE: 'Element',
    SUPPLIER_DOCUMENT_LABEL_CREATE_DATE: 'Issue Date',
    SUPPLIER_DOCUMENT_LABEL_RECEIVE_DATE: 'Date Received',
    SUPPLIER_DOCUMENT_LABEL_NOTE: 'Notes',
    SUPPLIER_DOCUMENT_LABEL_STATUS: 'Status',
    SUPPLIER_DOCUMENT_LABEL_MODEL: 'Models',
    SUPPLIER_DOCUMENT_HEADER_INFORMATION: 'Document Information (As-Given)',
    SUPPLIER_DOCUMENT_HEADER_ADDITIONAL: 'Additional Information',
    SUPPLIER_DOCUMENT_CREATE_DATE_REQUIRED: 'Issue Date is required',
    SUPPLIER_DOCUMENT_RECEIVE_DATE_REQUIRED: 'Date Received is required',

    RECORD_CREATED_AUTOMATICALLY: 'Created automatically.',
    RECORD_LABEL_NOTE: 'Note',
    RECORD_LABEL_OWNER: 'Owner',
    RECORD_LABEL_CREATE_DATE: 'Date',
    RECORD_LABEL_STATUS: 'Status',
    RECORD_LABEL_MODEL: 'Models',

    DELIVERY_LIST_LABEL_NOTE: 'Note',
    DELIVERY_LIST_LABEL_DELIVERED_TO: 'Delivered to',
    DELIVERY_LIST_LABEL_DELIVERED_BY: 'Delivered by',
    DELIVERY_LIST_LABEL_SENT_DATE: 'Sent Date',
    DELIVERY_LIST_LABEL_STATUS: 'Status',
    DELIVERY_LIST_LABEL_SENT_REFERENCE: 'Sent Reference',
    DELIVERY_LIST_LABEL_RECEIPT_REFERENCE: 'Receipt Reference',

    REPORT_LABEL_SCHEME: 'Report Scheme',
    REPORT_LABEL_NOTE: 'Note',
    REPORT_LABEL_CREATE_DATE: 'Created Date',
    REPORT_LABEL_STATUS: 'Status',

    SERIAL_NUMBER_LABEL_PROJECT: 'Project',
    SERIAL_NUMBER_LABEL_ORG_CODE: 'Organisation Code',
    SERIAL_NUMBER_CREATED_AUTOMATICALLY: 'Created automatically.',
    SERIAL_NUMBER_CI_NUMBER: 'CI Number',
    SERIAL_NUMBER_LABEL_DESCRIPTION: 'Description',
    SERIAL_NUMBER_LABEL_CREATE_DATE: 'Added',
    SERIAL_NUMBER_LABEL_REFERENCE_DOCS: 'Reference Documents',

    QA_DOCUMENT_LABEL_AREA: 'Area',
    QA_DOCUMENT_LABEL_TYPE: 'Type',
    QA_DOCUMENT_LABEL_ISO_SECTION_NUMBER: 'ISO Section Number',
    QA_DOCUMENT_LABEL_ISSUE_NUMBER: 'Issue',
    QA_DOCUMENT_LABEL_REVISION: 'Revision',
    QA_DOCUMENT_LABEL_NOTE: 'Note',
    QA_DOCUMENT_INFO_NOTE: 'Notes are carried forward into future versions.',
    QA_DOCUMENT_LABEL_OWNER: 'Owner',
    QA_DOCUMENT_LABEL_ISSUE_DATE: 'Issue Date',
    QA_DOCUMENT_LABEL_STATUS: 'Status',
    QA_DOCUMENT_LABEL_MODEL: 'Models',
    QA_DOCUMENT_ISO_NUMBER_TOO_LARGE: 'ISO Section Number should be between 1 and 10',

    QMS_DOCUMENT_LABEL_AREA: 'Area',
    QMS_DOCUMENT_LABEL_TYPE: 'Type',
    QMS_DOCUMENT_LABEL_ISO_SECTION_NUMBER: 'ISO Section Number',
    QMS_DOCUMENT_LABEL_ISSUE_NUMBER: 'Issue',
    QMS_DOCUMENT_LABEL_REVISION: 'Revision',
    QMS_DOCUMENT_LABEL_NOTE: 'Note',
    QMS_DOCUMENT_INFO_NOTE: 'Notes are carried forward into future versions.',
    QMS_DOCUMENT_LABEL_OWNER: 'Owner',
    QMS_DOCUMENT_LABEL_ISSUE_DATE: 'Issue Date',
    QMS_DOCUMENT_LABEL_STATUS: 'Status',
    QMS_DOCUMENT_LABEL_MODEL: 'Models',
    QMS_DOCUMENT_ISO_NUMBER_TOO_LARGE: 'ISO Section Number should be between 1 and 10',

    QA_RECORD_LABEL_TYPE: 'Type',
    QA_RECORD_CREATED_AUTOMATICALLY: 'Created automatically.',
    QA_RECORD_LABEL_NOTE: 'Note',
    QA_RECORD_LABEL_OWNER: 'Owner',
    QA_RECORD_LABEL_CREATE_DATE: 'Date',
    QA_RECORD_LABEL_STATUS: 'Status',
    
    ADMIN_USER_NOTE_ROLES: 'You can Disable or re-enable their system access at any time with the User checkbox below.',

    TYPE_CODE_MAP_ARCHIVED_NOTE: 'Archived Type-Code Mappings are not available for further selection.',

    SELECT_ALL: '(Select all)',
    SELECT_ALL_IN_SEARCH: '(Select All Search Results)',
    NO_RESULTS: 'No results',

    ERROR_MESSAGE_DEFAULT: 'Sorry! An error has occured while saving. <a className=\'alert-link\' onClick=\'window.location.reload()\'>Please click here to reload this page</a>.',
    ERROR_MESSAGE_NOACCESS: 'Sorry, additional Role or Project permissions are needed to do this.',
    ERROR_MESSAGE_EMAIL: 'The given email address is not valid.',
    ERROR_MESSAGE_DUPLICATE_NAME: 'That name already exists',
    ERROR_MESSAGE_ALREADY_INCLUDED: 'The selected Document has already been included',
}

export function PscPhrase(key) {
    return phraseMap[key] || '<Missing phrase for '+key+'>'
}
